<template>
  <div class="apply-stepper">
    <div class="apply-stepper__bar">
      <div class="apply-stepper__fill" :style="{ width: pct + '%' }"></div>
    </div>
    <div class="apply-stepper__label">
      Paso {{ current }} de {{ total }}
    </div>
  </div>
</template>

<script>
export default {
  name: 'ApplyStepper',
  props: {
    current: { type: Number, required: true },
    total: { type: Number, default: 10 },
  },
  computed: {
    pct() {
      return Math.round((this.current / this.total) * 100)
    },
  },
}
</script>

<style scoped>
.apply-stepper { margin-bottom: 1.5rem; }
.apply-stepper__bar {
  background: #f1f1f1;
  border-radius: 999px;
  height: 8px;
  overflow: hidden;
}
.apply-stepper__fill {
  background: #f7a800;
  height: 100%;
  transition: width 200ms ease;
}
.apply-stepper__label {
  text-align: right;
  font-size: 0.8rem;
  color: #888;
  margin-top: 0.25rem;
}
</style>
